var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6d6dff",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m431.8,302.3v-80.5c0-11.3-9.1-20.4-20.4-20.4h-308.8c-11.3,0-20.4,9.1-20.4,20.4v80.5c-18.3-14.6-29.3-35.8-29.3-58.6 0-30.6 20-58.4 50.8-71 9.5-3.9 14.7-14.2 12.1-24.1-1.6-6.2-2.4-12.2-2.4-18 0-42.9 38.6-77.9 86-77.9 32.9,0 62.4,16.7 77.1,43.5 5.1,9.4 16.7,13.3 26.5,8.8 12.2-5.6 25.3-8.5 38.8-8.5 46.4,0 84.9,34.2 85.9,76.2 0.1,5.7 2.7,11.1 7,14.9 17.1,14.9 26.5,34.8 26.5,56.1-5.68434e-14,22.9-11,44.1-29.4,58.6zm-40.8,89.1h-268v-149.2h268v149.2zm111-147.6c0-29.9-12.3-58.9-34.1-80.8-6.1-60.8-59.9-107.2-126.2-107.2-13.5,0-26.6,2-39.2,5.9-23.6-31-61.7-49.7-103.2-49.7-70,0-126.9,53.2-126.9,118.7 0,3.8 0.2,7.7 0.6,11.6-37.5,21.3-61,59.6-61,101.5 0,45.2 27.3,86.2 70.2,106.2v61.8c0,11.3 9.1,20.4 20.4,20.4h134v28.9h-54.8c-11.3,0-20.4,9.1-20.4,20.4 0,11.3 9.1,20.4 20.4,20.4h150.5c11.3,0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4h-54.8v-28.9h134c11.3,0 20.4-9.1 20.4-20.4v-61.8c42.8-20 70.1-60.9 70.1-106.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.2942cbf27dd8ae4fdad1580d5e8fdc35.svg";
export { ForwardRef as ReactComponent };